import Splide from '@splidejs/splide';

const EL = '.js-FamousCarousel'
const EL_SIG = '.js-FamousCarouselSignatures'

if(document.querySelector(EL)){
  const carousel1 = new Splide( EL, {
    type: 'fade',
    rewind: true,
    arrows: false,
    autoplay: true,
    pagination: false
  } )

  const carousel2 = new Splide( EL_SIG, {
    type: 'fade',
    rewind: true,
    arrows: false,
    pagination: true,
    fixedHeight: 80
  } )

  carousel1.sync( carousel2 );
  carousel1.mount();
  carousel2.mount();
}
